module.exports = __webpack_public_path__ + "img/neudorf-wine.1825b6dd.jpg";